import React, { FC, useMemo } from 'react';
import { useTranslate } from 'react-admin';
import { queryClient } from '~/App';
import { TenantType } from '~/api/utils';
import { tenantQueryKey } from '~/hooks/tenant';
import { useHandbooksQuery } from '~/hooks/useHandbook';
import SelectInput from './SelectInput';

type BranchSelectProps = {
  name: string;
  value?: string | null;
  onChange: (e: { target: { name: string; value: any } } | React.ChangeEvent<any>) => void;
  className?: string;
  allowEmpty?: boolean;
  disabled?: boolean;
};

const BranchSelect: FC<BranchSelectProps> = ({
  name,
  value = '',
  onChange,
  className,
  allowEmpty = true,
  disabled,
}) => {
  const translate = useTranslate();
  const t = (key: string, args?: any) => translate(key, args);

  const tenant = queryClient.getQueryData<TenantType>(tenantQueryKey);
  const { data: handbook, isFetching } = useHandbooksQuery(tenant?.id);

  const options = useMemo(() => {
    return (
      handbook?.branches
        ?.map((b: any) => ({ value: b.id, text: b.name || b.id }))
        ?.sort((a, b) => a.text.localeCompare(b.text)) || []
    );
  }, [handbook]);

  return (
    <SelectInput
      label={t('components.ra.inputs.BranchSelect.branch')}
      name={name}
      value={value ?? ''}
      onChange={onChange as any}
      className={className}
      options={options}
      allowEmpty={allowEmpty}
      emptyText={t('utils.any')}
      disabled={disabled || isFetching}
      fullWidth
    />
  );
};

export default BranchSelect;
